import { signs } from '../../shared/util';

export const initial = { signs: signs };
